"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuickDateSelectValue = exports.quickDateOptionMap = exports.quickDateOptions = exports.quickDateOptionsLabelMap = void 0;
var moment_1 = __importDefault(require("moment"));
var transifex_1 = require("../../transifex");
exports.quickDateOptionsLabelMap = {
    today: transifex_1.TX_TODAY,
    this_week: transifex_1.TX_THIS_WEEK,
    past_7_days: transifex_1.TxPastDaysNum(7),
    this_month: transifex_1.TX_THIS_MONTH,
    last_30_days: transifex_1.TxPastDaysNum(30),
    past_3_months: transifex_1.TxPastMonthsNum(3),
    past_6_months: transifex_1.TxPastMonthsNum(6),
    past_year: transifex_1.TX_PAST_YEAR,
    this_year: transifex_1.TX_THIS_YEAR,
    custom: transifex_1.TX_CUSTOM,
};
exports.quickDateOptions = Object.keys(exports.quickDateOptionsLabelMap).map(function (key) { return ({
    label: exports.quickDateOptionsLabelMap[key],
    value: key,
}); });
exports.quickDateOptionMap = {
    today: function () { return [moment_1.default().startOf("day"), moment_1.default().endOf("day")]; },
    this_week: function () { return [moment_1.default().startOf("week"), moment_1.default().endOf("week")]; },
    past_7_days: function () { return [
        moment_1.default().subtract(7, "days"),
        moment_1.default().subtract(1, "days"),
    ]; },
    this_month: function () { return [moment_1.default().startOf("month"), moment_1.default().endOf("month")]; },
    last_30_days: function () { return [
        moment_1.default().subtract(30, "days"),
        moment_1.default().subtract(1, "days"),
    ]; },
    past_3_months: function () { return [
        moment_1.default().subtract(3, "months").startOf("month"),
        moment_1.default().subtract(1, "month").endOf("month"),
    ]; },
    past_6_months: function () { return [
        moment_1.default().subtract(6, "months").startOf("month"),
        moment_1.default().subtract(1, "month").endOf("month"),
    ]; },
    past_year: function () { return [
        moment_1.default().subtract(1, "year").startOf("year"),
        moment_1.default().subtract(1, "year").endOf("year"),
    ]; },
    this_year: function () { return [moment_1.default().startOf("year"), moment_1.default().endOf("year")]; },
    custom: function () { return [moment_1.default().subtract(1, "day"), moment_1.default().add(1, "day")]; },
};
var getQuickDateSelectValue = function (value) {
    if (!value) {
        return "custom";
        // eslint-disable-next-line no-else-return
    }
    else {
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (var key in exports.quickDateOptionsLabelMap) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var date = exports.quickDateOptionMap[key]();
            if ((date === null || date === void 0 ? void 0 : date[0].isSame(value[0], "date")) &&
                (date === null || date === void 0 ? void 0 : date[1].isSame(value[1], "date"))) {
                return key;
            }
        }
    }
    return "custom";
};
exports.getQuickDateSelectValue = getQuickDateSelectValue;
